module.exports = __webpack_public_path__ + "media/images/el_liberal-f5d811f1cb832a107fe95ac5606c4600.jpg";